export { default } from './WidgetEditControls';
